/** @format */

export default class WebshopCookies {
	static getCookie(name) {
		const v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
		return v ? decodeURIComponent(v[2]) : null;
	}

	static setCookie(name, value, days, path = "/", domain = "") {
		const d = new Date();

		d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);

		let cookie = `${name}=${encodeURIComponent(value)};path=${path};expires=${d.toUTCString()}`;

		if (domain) {
			cookie += `;domain=${domain}`;
		}

		document.cookie = cookie;
	}

	static deleteCookie(name, path = "/", domain = "") {
		let cookie = `${name}=;path=${path};expires=Thu, 01 Jan 1970 00:00:00 GMT`;

		if (domain) {
			cookie += `;domain=${domain}`;
		}

		document.cookie = cookie;
	}
}
